<div class="add-to-cart-bottom-sheet">
    <div class="bottom-sheet-extra-info bottom-sheet-scroll appear plp-extra-info sm:visible">
        @if (vm?.product?.status?.selectedColor) {
            <div>
                @if (sheetModel()?.fullView) {
                    <div class="m-20">
                        <div class="is-flex content-sp-between">
                            <h1 class="title-m ttu has-ellipsis">
                                {{ vm?.product.name }}
                            </h1>
                            <md-icon class="close-qr-icon" name="close" (click)="closeButtonSheet($event)"></md-icon>
                        </div>

                        @if (vm?.priceInfoView) {
                            <product-prices
                                [product]="vm.product"
                                [hasPromotion]="vm.hasPromotion"
                                [productPrices]="vm.priceInfoView"
                                [showPricesInFlexMode]="true"
                                [alternativePricesClass]="'text-m'"
                                [pricesClasses]="{ titleLarge: true }"
                            ></product-prices>
                        }
                    </div>

                    <slide-elements [nativeScroll]="true" [hideScroll]="true" [customScroll]="true" (click)="goToProduct($event)">
                        @for (item of vm?.images; track item) {
                            <product-media-skeleton
                                class="slide-elements-div_custom"
                                [imageUrl]="item.path"
                                [mediaConfig]="{
                                    alt: item.path,
                                    widthVW: '(max-width: 1280px) 20vw, 30vw',
                                    ratio: '3-4',
                                    clickable: true
                                }"
                            ></product-media-skeleton>
                        }
                    </slide-elements>
                }

                <div class="row mb-32 pt-20" [class.pt-40]="!vm?.showColors">
                    <div class="col-xs-12 text-center">
                        @if (vm?.showColors) {
                            <product-color-selector
                                class="pdp-colors w-100"
                                id="productColor"
                                [colors]="vm?.product.colors"
                                [selectedColor]="vm?.product.status.selectedColor"
                                [showMoreColors]="false"
                                [showColorName]="true"
                                [showAllColors]="true"
                                [displayReference]="vm?.product.displayReference"
                                (colorChangeEvent)="changeColor($event)"
                                [isBulletselector]="true"
                                [classConfig]="{ wrap: 'mb-4' }"
                            ></product-color-selector>
                            <hr class="border-t sm:visible mb-24" />
                        }

                        <p class="title-s mb-20">
                            {{ 'dev.product.sizeChoose' | translate }}
                        </p>

                        <div class="px-20">
                            @if (vm?.showSizes) {
                                <product-size-selector-layout
                                    id="productSizes"
                                    [sizes]="vm?.product.status.selectedColor.sizes"
                                    [product]="vm?.product"
                                    (sizeSelectedEvent)="sizeSelected($event)"
                                    (checkStockAvailability)="checkStock($event)"
                                >
                                </product-size-selector-layout>
                            }
                        </div>
                    </div>
                </div>

                @if (vm?.showMeasurement) {
                    <div class="row text-center mb-32">
                        <div class="col-xs-12">
                            <product-fit-size-message
                                [measurementLabel]="vm.measurementModel.measurementLabel"
                                [measurement]="vm.measurementModel.measurement"
                                [product]="vm.product"
                            >
                            </product-fit-size-message>
                        </div>
                    </div>
                }

                @if (mocacoRepeated) {
                    <div class="p-20 bg-primary c-white">
                        <div class="row">
                            <div class="col-xs-12 text-center">
                                <p class="title-s mb-20 ttu">
                                    {{ 'dev.product.size.doubts' | translate }}
                                </p>

                                <p class="title-s">
                                    {{ 'dev.product.recommender' | translate }}
                                </p>
                            </div>
                        </div>
                    </div>
                }

                @if (!vm?.product.status.selectedColor.uniqueSize) {
                    <hr class="border-t sm:visible mb-20" />
                    <div class="px-20">
                        <div class="row">
                            <div class="col-xs-12">
                                <app-size-guide [product$$]="vm?.product" (openSizeGuideClicked)="openSizeGuide($event)"></app-size-guide>
                            </div>
                        </div>
                    </div>
                }
            </div>
        }
    </div>
    <div id="bottom-sheet-extra-info-overlay" class="bottom-sheet-extra-info-overlay" (click)="closeButtonSheet($event)"></div>
</div>
